const REFERRAL_ROUTES = ["/referrals", "/new-home-start"] as const;
const ENTRY_KEY = "referral_compare_entry";

const REFERRAL_FORM_FIELDS = [
  "from_referrals",
  "referral_source",
  "referrer_first_name",
  "referrer_last_name",
] as const;

let decisionThisLoad: boolean | undefined;

const normalizePath = (path: string): string => {
  if (!path) return "";
  const pathname = path.split("#")[0]?.split("?")[0]?.trim() || "";
  if (pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "";
};

export const isReferralRoute = (path: string): boolean =>
  REFERRAL_ROUTES.some((route) => normalizePath(path) === route);

export const isCompareFormPath = (path: string): boolean =>
  normalizePath(path) === "/compare";

const storage = (): Storage | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const stripReferralFormValues = <T extends Record<string, unknown>>(
  formValues: T,
): T => {
  const next = { ...formValues };
  REFERRAL_FORM_FIELDS.forEach((field) => {
    delete next[field];
  });
  return next;
};

export const markReferralCompareEntry = (): void => {
  decisionThisLoad = undefined;
  storage()?.setItem(ENTRY_KEY, "true");
};

export const clearReferralCompareEntry = (): void => {
  decisionThisLoad = undefined;
  storage()?.removeItem(ENTRY_KEY);
};

const consumeEntry = (): boolean => {
  const entry = storage();
  if (entry?.getItem(ENTRY_KEY) !== "true") return false;
  entry.removeItem(ENTRY_KEY);
  return true;
};

export const resolveCompareReferralState = (
  stepId: string | null | undefined,
  options?: { forceNewFlow?: boolean; persistedFromReferrals?: boolean },
): boolean => {
  if (options?.forceNewFlow) {
    clearReferralCompareEntry();
    decisionThisLoad = false;
    return false;
  }

  if (decisionThisLoad !== undefined) return decisionThisLoad;

  if (consumeEntry()) {
    decisionThisLoad = true;
    return true;
  }

  decisionThisLoad = Boolean(stepId) && options?.persistedFromReferrals === true;
  return decisionThisLoad;
};

export const syncReferralEntryForNavigation = (
  sourcePath: string,
  targetPath: string,
): void => {
  if (!isCompareFormPath(targetPath)) return;

  if (isReferralRoute(sourcePath)) {
    markReferralCompareEntry();
    return;
  }

  if (!isCompareFormPath(sourcePath)) {
    clearReferralCompareEntry();
  }
};
